export default {
	get_the_code: {
		order: 0,
		title: 'Mobile Verification',
		back: true,
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	},
	verify_code: {
		order: 1,
		title: 'Enter Code',
		back: true,
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile/enter-the-code',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	},
	success: {
		order: 2,
		title: '',
		back: null,
		skip: null,
		close: true,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile/verified',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	},
	error: {
		order: 3,
		title: '',
		back: true,
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile/error',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	}


};



// WEBPACK FOOTER //
// ./mobile-core/src/verification/mobile-config.js